import { render, staticRenderFns } from "./AdminPromotionSettings.vue?vue&type=template&id=364c43ad&scoped=true"
import script from "./AdminPromotionSettings.vue?vue&type=script&lang=js"
export * from "./AdminPromotionSettings.vue?vue&type=script&lang=js"
import style0 from "./AdminPromotionSettings.vue?vue&type=style&index=0&id=364c43ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364c43ad",
  null
  
)

export default component.exports